import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import RequestDetail from './components/RequestDetail';
import ApiService from './services/api';
import './App.css';

// Componente para proteger rutas que requieren autenticación
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = ApiService.isAuthenticated();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Componente para redirigir usuarios autenticados lejos del login
const PublicRoute = ({ children }) => {
  const isAuthenticated = ApiService.isAuthenticated();
  return !isAuthenticated ? children : <Navigate to="/dashboard" replace />;
};

function App() {
  const [theme, setTheme] = useState(() => {
    const saved = window.localStorage.getItem('ismo.portal.theme');
    return saved === 'light' ? 'light' : 'dark';
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('theme-light', 'theme-dark');
    root.classList.add(theme === 'light' ? 'theme-light' : 'theme-dark');
    window.localStorage.setItem('ismo.portal.theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Ruta raíz - redirige según el estado de autenticación */}
          <Route 
            path="/" 
            element={
              ApiService.isAuthenticated() ? 
                <Navigate to="/dashboard" replace /> : 
                <Navigate to="/login" replace />
            } 
          />
          
          {/* Ruta de login - solo accesible si no está autenticado */}
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <Login theme={theme} onToggleTheme={toggleTheme} />
              </PublicRoute>
            } 
          />
          
          {/* Ruta del dashboard - requiere autenticación */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard theme={theme} onToggleTheme={toggleTheme} />
              </ProtectedRoute>
            } 
          />
          
          {/* Ruta de detalles de solicitud - requiere autenticación */}
          <Route 
            path="/request/:id" 
            element={
              <ProtectedRoute>
                <RequestDetail theme={theme} onToggleTheme={toggleTheme} />
              </ProtectedRoute>
            } 
          />
          
          {/* Ruta 404 - página no encontrada */}
          <Route 
            path="*" 
            element={
              <div className="not-found">
                <div className="not-found-content">
                  <h1>404</h1>
                  <h2>Página no encontrada</h2>
                  <p>La página que buscas no existe.</p>
                  <button 
                    onClick={() => window.location.href = '/'}
                    className="btn btn-primary"
                  >
                    Ir al Inicio
                  </button>
                </div>
              </div>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
